export default __webpack_public_path__ + "static/media/brand1.df95f514.svg";